var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-badge",
    {
      attrs: {
        value: _vm.pendingMsgList.length,
        "is-dot": "",
        hidden: _vm.pendingMsgList.length === 0
      }
    },
    [
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom",
            width: "580",
            trigger: "click",
            offset: 30
          },
          on: { show: _vm.show, hide: _vm.hide },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _vm.pendingMsgList.length > 0
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: !_vm.showMessage,
                      expression: "!showMessage"
                    }
                  ],
                  staticClass: "after-msg-wrap",
                  style: { "min-height": _vm.minheight }
                },
                [
                  _c("i", {
                    staticClass: "el-icon-close msg-close",
                    on: {
                      click: function($event) {
                        _vm.visible = false
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.showMessage
                    ? _c(
                        "div",
                        { staticStyle: { "padding-bottom": "30px" } },
                        _vm._l(_vm.pendingMsgList, function(item) {
                          return _c(
                            "div",
                            { key: item.id, staticClass: "msg-item" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-row-between-center" },
                                [
                                  item.type == 2
                                    ? _c(
                                        "span",
                                        { staticClass: "msg-title after" },
                                        [_vm._v("售后消息")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.type == 3
                                    ? _c(
                                        "span",
                                        { staticClass: "msg-title refuse" },
                                        [_vm._v("拒收消息")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.time))])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex-row-between-center" },
                                [
                                  _c("div", {}, [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v("服务编码：" + _vm._s(item.number))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "c-65" }, [
                                      _vm._v(
                                        "（" +
                                          _vm._s(item.strTag) +
                                          "，请及时跟进）"
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  item.type == 2
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "handle-btn",
                                          on: {
                                            click: function($event) {
                                              return _vm.handleMsg(item)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v("去处理\n              "),
                                          _c("i", {
                                            staticClass: "el-icon-arrow-right",
                                            staticStyle: { "font-size": "12px" }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "go-all-btn",
                      style: {
                        top:
                          82 * _vm.pendingMsgList.length > 440
                            ? "520px"
                            : 82 * _vm.pendingMsgList.length + 80 + "px"
                      },
                      on: { click: _vm.checkAll }
                    },
                    [_vm._v("\n        查看全部\n      ")]
                  )
                ]
              )
            : _c("div", { staticClass: "no-msg-data" }, [
                _vm._v("\n      暂无数据\n    ")
              ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: { "font-size": "12px" },
              attrs: { slot: "reference" },
              slot: "reference"
            },
            [_vm._v("待处理通知")]
          ),
          _vm._v(" "),
          _c("asOrderDialogVue", {
            ref: "asDialogRef",
            attrs: { item: _vm.item }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f78f192", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f78f192","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/afterMsgPop.vue
// module id = null
// module chunks = 